import React, { useMemo } from "react";
import { Box, Button, IconButton, Tooltip, Typography } from "@mui/material";
import HistoryIcon from "@mui/icons-material/History";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Inventory } from "@mui/icons-material";

const OrderListItem = ({ order, buttonText = 'Track Quote', onTrack }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  // Derive PO number from available order fields (prefer order_data.po_number)
  const poNumber = useMemo(() => {
    try {
      if (!order) return "—";
      // Direct property
      if (order.order_po) return order.order_po;
      // Nested order_data structures
      if (order.order_data) {
        const od = typeof order.order_data === 'string' ? JSON.parse(order.order_data) : order.order_data;
        if (od?.po_number) return od.po_number;
        if (od?.details?.po_number) return od.details.po_number;
        if (od?.payment_details?.po_number) return od.payment_details.po_number;
      }
      if (order.details?.po_number) return order.details.po_number;
      // Fallbacks
      if (order.sub_name) return order.sub_name;
    } catch (_) { }
    return "—";
  }, [order]);

  const handleVisit = () => {
    const params = new URLSearchParams();
    // order from search results may use product_id for order_id and name for order_number
    const orderId = order?.order_id ?? order?.product_id;
    const orderNumber = order?.order_number ?? order?.name;
    if (orderId) params.set('open_id', orderId);
    if (orderNumber) params.set('open_number', orderNumber);
    // If onTrack is provided (e.g., Track Order page), call it instead of navigating
    if (typeof onTrack === 'function') {
      onTrack({ orderId, orderNumber, order });
    } else {
      navigate(`/track-quote${params.toString() ? `?${params.toString()}` : ''}`);
    }
  };

  const handleHistoryVisit = () => {
    const params = new URLSearchParams();
    const orderId = order?.order_id ?? order?.product_id;
    const orderNumber = order?.order_number ?? order?.name;
    if (orderId) params.set('open_id', orderId);
    if (orderNumber) params.set('open_number', orderNumber);
    navigate(`/order-history${params.toString() ? `?${params.toString()}` : ''}`);
  };
  return (
    <Box
      sx={{
        width: "100%",
        maxHeight: "75px",
        borderRadius: 2,
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        backgroundColor: "#fff",
        boxShadow: "0 0 6px 1px rgba(0,0,0,0.1)",
        p: 2,
        columnGap: 2,
        margin: "7px 0",
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", minWidth: 0 }}>
        <Typography variant="body1" sx={{ fontWeight: "bold", fontSize: "12px", whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '240px' }}>
          {order.name}
        </Typography>
        {/* <Typography variant="body2" color="text.secondary" sx={{ fontSize: "11px", whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '240px' }}>
          PO: {poNumber}
        </Typography> */}
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', columnGap: 0 }}>
        <Button size="small" endIcon={<HistoryIcon />} onClick={handleVisit}>
          {buttonText}
        </Button>

        <Button size="small" endIcon={<Inventory />} onClick={handleHistoryVisit}>
          {t('LABELS.VIEW_IN_ORDER_HISTORY')}
        </Button>
      </Box>
    </Box>
  );
};

export default OrderListItem;
